<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('bank') }}</div>
      <div>
        <router-link class="btn-blue" to="bank">{{ $t('bank') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="bankDetails.bank_name"
                v-validate="{required: 'required', regex:/^[a-zA-Z ]*$/}"
                placeholder="."
                type="text"
                name="bank_name"
                id="bank_name"
              />
              <label>{{ $t('bank') }} {{ $t('name') }}</label>
            </div>
            <Tooltip :title="$tc('enterBankName')"  />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('bank_name')">{{ errors.first('bank_name') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input v-model="bankDetails.bank_address" type="text" name="floatamount" />
              <label>{{ $t('address') }}</label>
            </div>
            <Tooltip :title="$tc('enterBankAddress')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Country.length > 0 ? 'shift-up' : '' ">{{ $tc('country', 1) }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(country, countryIndex) in Countries"
                  :key="countryIndex"
                  v-on:click="onSelectHandler('country',country)"
                  name="selectcountry"
                  id="selectcountry"
                >{{ country.country_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="Countries"
                v-model="selected_country"
                :searchable="true"
                label="country_name"
                track-by="country_name"
                placeholder="."
                @input="onSelectHandler('country',$event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$tc('selectTheBankResides')"  />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selected.State.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('state', 1) }}</label>
            <div class="dropdown-curve-container">
              <!-- <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(state, stateIndex) in States"
                  :key="stateIndex"
                  @click="onSelectHandler('state',state)"
                  name="selectstate"
                  id="selectstate"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="States"
                v-model="selected_state"
                :searchable="true"
                label="state_name"
                track-by="state_name"
                placeholder="."
                :allowEmpty="false"
                :showLabels="false"
                @input="onSelectHandler('state',$event)"
              ></multiselect>
            </div>
            <p class="error_message">
              <span>{{ }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selected.City.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('city', 1) }}</label>
            <div class="dropdown-curve-container">
              <!-- <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(city, cityIndex) in Cities"
                  :key="cityIndex"
                  @click="onSelectHandler('city',city)"
                  name="selectcity"
                  id="selectcity"
                >{{ city.city_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="Cities"
                v-model="selected_city"
                :searchable="true"
                label="city_name"
                track-by="city_name"
                placeholder="."
                :allowEmpty="false"
                :showLabels="false"
                @input="onSelectHandler('city',$event)"
              ></multiselect>
            </div>
            <p class="error_message">
              <span>{{ }}</span>
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label for="file-selector" class="file-selector w-100">
              <label
                class="file-selector-label"
                :class="bankDetails.bank_logo_url && bankDetails.bank_logo_url.length > 0 ? 'shift-up' : ''"
              >{{ $t('uploadbanklogo') }}</label>
              <span>{{bankDetails.bank_logo_url}}</span>
              <input
                v-on:change="uploadImage($event)"
                type="file"
                class="d-none"
                id="file-selector"
              />
            </label>

            <Tooltip :title="$tc('LogoShouldbeOfDimension')"  />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="bankDetails.bank_is_active"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true) " class="btn-blue">{{ $t('save') }}</button>
          <!-- <button class="btn-blue">{{ $t('saveaddmore') }}</button>
          <button class="btn-black">{{ $t('reset') }}</button>-->
          <b-button class="btn-outline-grey" variant="default" to="bank">{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
const selected = {
  Country: "",
  State: "",
  City: ""
};

export default {
  data() {
    return {
         selected_country: null,
      selected_state: null,
      selected_city: null,
      submitted: false,
      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states"
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },
      selected: selected,
      items: [],
      bankDetails: {
        bank_name: null,
        bank_logo_url: null,

        bank_address: null,
        country_id: null,
        state_id: null,
        city_id: null,
        bank_is_active: "Y"
      }
    };
  },
  beforeMount() {
    const { bank_id } = this.$route.query;

    this.getCountriesList();

    if (bank_id) {
      this.getBankDetails(bank_id);
    } else {
      const { bank_id } = this.$route.query;
      this.bank_id = this.$route.query.user_id;

      if (bank_id) {
        this.getBankDetails(bank_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {},
  methods: {
    onResetForm: function() {
      this.bankDetails = {
        bank_logo_url: null,
        bank_is_active: "N",
        bank_id: null,
        bank_name: null,
        bank_address: null,
        city_id: null,
        state_id: null,
        country_id: null
      };
      this.selected = {
        City: "",
        Country: "",
        State: ""
      };
    },
    getBankDetails: function(bank_id) {
      MarketingService.getBankDetails({ bank_id }).then(response => {
        const { data } = response;
        if (data.Records) {
          this.bankDetails = {
            ...this.bankDetails,
            ...data.Records[0]
          };
          // console.log("bankDetails :", this.bankDetails);
        }
        this.getCountryList(this.bankDetails.country_id || null);
        this.getStateList(
          this.bankDetails.country_id || null,
          this.bankDetails.state_id || null
        );
        this.getCityList(
          this.bankDetails.state_id || null,
          this.bankDetails.city_id || null
        );
      });
    },
    // },
    getCountryList: function(country_id) {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            if (country_id) {
              this.Countries.map(x => {
                if (country_id === x.country_id) {
                  this.selected_country = x

                  this.selected.Country = x.country_name;
                  // console.log("this.selected.Country :", this.selected.Country);
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStateList: function(country_id, state_id) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;

            // console.log("States ", this.States);
            // console.log("States Id ", state_id);

            if (state_id) {
              this.States.map(x => {
                if (state_id === x.state_id) {
                  this.selected_state = x

                  this.selected.State = x.state_name;
                  // console.log(" this.selected.State ", this.selected.State);
                }
              });
            }
          } else {
            // this.$toasted.show("state"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCityList: function(state_id, city_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
            if (city_id) {
              this.Cities.map(x => {
                if (city_id === x.city_id) {
                  this.selected_city = x

                  this.selected.City = x.city_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("City"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCountriesList: function() {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStatesList: function(cid) {
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: cid
      };
      MasterService.GetActiveList(payload)
        // this.States = [];
        // let body = this.getRequestBody("GET", undefined, {
        //   ...this.StatesMethod,
        //   params: { id: "country_id-" + country_id }
        // });
        // MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.States = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCitiesList: function(s_id) {
      this.Cities = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: s_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function(type, value) {
      if (type == "bank_name") {
        this.bankDetails.bank_name = value.bank_name;
      } else if (type == "bank_address") {
        this.bankDetails.bank_address = value.bank_address;
      } else if (type == "country") {
        // console.log("value :", value);
        this.selected.country_id = value.country_id;
        this.selected.Country = value.country_name;
        this.bankDetails.country_id = value.country_id;
         this.selected.State = '';
        this.bankDetails.state_id = null
         this.selected.City = ''
          this.bankDetails.city_id = null;
          this.Cities = []
         this.selected_state = null;
        this.selected_city = null;
        // console.log("this.selected.Country :", this.selected.Country);
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        (this.selected.State = value.state_name),
          (this.bankDetails.state_id = value.state_id),
          this.getCitiesList(value.state_id);
           this.selected.City = ''
          this.bankDetails.city_id = null;
          this.selected_city = null;
      } else if (type == "city") {
        (this.selected.City = value.city_name),
          (this.bankDetails.city_id = value.city_id);
      }
    },

    uploadImage: function(image) {
      // console.log("imagee",image);
      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "Bank Image");
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.bankDetails.bank_logo_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError);
    },

    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator
        .validate()
        .then(valid => {
          if (valid) {
            MarketingService.editBank({ ...this.bankDetails }).then(
              response => {
                const { data } = response;
                if (data.status) {
                  this.$toasted.show(data.message);
                  this.onResetForm();
                  if (redirect) {
                    // console.log("redirect value ", redirect);
                    this.$router.push({
                      path: "/marketing/bank"
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              }
            );
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/bankComponents/editBank.vue